export const FilterPagesEnum = Object.freeze({
    LIST: 'list',
    CATEGORIES: 'categories'
});
